import { gql } from '@apollo/client';

// Content queries
export const LIST_CONTENT = gql`
  query ListContent(
    $type: String
    $status: String
    $language: String
    $page: Int
    $limit: Int
    $searchTerm: String
  ) {
    list_content(
      type: $type
      status: $status
      language: $language
      page: $page
      limit: $limit
      searchTerm: $searchTerm
    ) {
      hasError
      message
      data {
        contents {
          _id
          type
          status
          metadata {
            title
            description
            slug
            author
            thumbnail
            tags
            featured
            datePublished
            dateModified
          }
          translations {
            language
            content
            excerpt
            isActive
          }
          seo {
            metaTitle
            metaDescription
            keywords
            canonicalUrl
            ogImage
            ogType
            schema
          }
        }
        total
        page
        limit
        totalPages
      }
    }
  }
`;

export const GET_CONTENT = gql`
  query GetContent($id: String!) {
    get_content(id: $id) {
      hasError
      message
      data {
        _id
        type
        status
        metadata {
          title
          description
          slug
          author
          thumbnail
          tags
          featured
          datePublished
          dateModified
        }
        translations {
          language
          content
          excerpt
          isActive
        }
        seo {
          metaTitle
          metaDescription
          keywords
          canonicalUrl
          ogImage
          ogType
          schema
        }
      }
    }
  }
`;

export const SEARCH_CONTENT = gql`
  query SearchContent(
    $searchTerm: String!
    $type: String
    $language: String
    $limit: Int
  ) {
    search_content(
      searchTerm: $searchTerm
      type: $type
      language: $language
      limit: $limit
    ) {
      hasError
      message
      data {
        _id
        type
        status
        title
        description
        content
        excerpt
        slug
        author
        thumbnail
        tags
        featured
        datePublished
        dateModified
      }
    }
  }
`;

// Content mutations
export const CREATE_CONTENT = gql`
  mutation CreateContent($input: CreateContentInput!) {
    create_content(input: $input) {
      hasError
      message
      data {
        _id
        type
        status
        metadata {
          title
          description
          slug
          author
          thumbnail
          tags
          featured
          datePublished
          dateModified
        }
        translations {
          language
          content
          excerpt
          isActive
        }
        seo {
          metaTitle
          metaDescription
          keywords
          canonicalUrl
          ogImage
          ogType
          schema
        }
      }
    }
  }
`;

export const UPDATE_CONTENT = gql`
  mutation UpdateContent($id: String!, $input: UpdateContentInput!) {
    update_content(id: $id, input: $input) {
      hasError
      message
      data {
        _id
        type
        status
        metadata {
          title
          description
          slug
          author
          thumbnail
          tags
          featured
          datePublished
          dateModified
        }
        translations {
          language
          content
          excerpt
          isActive
        }
        seo {
          metaTitle
          metaDescription
          keywords
          canonicalUrl
          ogImage
          ogType
          schema
        }
      }
    }
  }
`;

export const DELETE_CONTENT = gql`
  mutation DeleteContent($id: String!) {
    delete_content(id: $id) {
      hasError
      message
      data {
        id
      }
    }
  }
`;
